<template>
  <div
    ref="chart"
    class="echarts-donut"
    role="img"
    :aria-label="ariaLabel"
  />
</template>

<script>
import echarts from '@/plugin/echarts'
import { localeState } from '@/i18n'

export default {
  name: 'EChartDonut',
  props: {
    items: { type: Array, required: true },
    total: { type: String, default: '0' },
    unit: { type: String, default: 'USDT' },
    ariaLabel: { type: String, default: '收益贡献环形图' }
  },
  data() {
    return {
      chart: null,
      resizeObserver: null
    }
  },
  computed: {
    currentLocale() {
      return localeState.current
    }
  },
  watch: {
    currentLocale() {
      this.renderChart()
    },
    items: {
      deep: true,
      handler() {
        this.renderChart()
      }
    },
    total() {
      this.renderChart()
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart, null, { renderer: 'canvas' })
    this.renderChart()

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.resize())
      this.resizeObserver.observe(this.$refs.chart)
    } else {
      window.addEventListener('resize', this.resize)
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', this.resize)
    }

    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    resize() {
      if (this.chart) this.chart.resize()
    },
    renderChart() {
      if (!this.chart) return

      const data = this.items.map(item => ({
        name: this.$t(item.name),
        value: Number(
          String(item.value !== undefined ? item.value : item.amount !== undefined ? item.amount : item.percent)
            .replace(/[+,]/g, '')
        ) || 0,
        itemStyle: { color: item.color }
      }))

      this.chart.setOption(
        {
          animationDuration: 700,
          aria: {
            enabled: true,
            description: this.$t(this.ariaLabel)
          },
          title: {
            text: this.total,
            subtext: this.unit,
            left: 'center',
            top: '37%',
            textStyle: {
              color: '#1b1f2a',
              fontSize: 17,
              fontWeight: 800
            },
            subtextStyle: {
              color: '#98a0af',
              fontSize: 11,
              lineHeight: 18
            }
          },
          tooltip: {
            trigger: 'item',
            confine: true,
            formatter: '{b}<br/>{c} USDT · {d}%',
            backgroundColor: 'rgba(8, 23, 55, 0.92)',
            borderWidth: 0,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          series: [
            {
              name: this.$t('收益贡献'),
              type: 'pie',
              radius: ['63%', '86%'],
              center: ['50%', '50%'],
              startAngle: 90,
              clockwise: true,
              avoidLabelOverlap: true,
              label: { show: false },
              labelLine: { show: false },
              emphasis: {
                scale: true,
                scaleSize: 5
              },
              itemStyle: {
                borderWidth: 0,
                borderRadius: 0
              },
              data
            }
          ]
        },
        true
      )
    }
  }
}
</script>

<style scoped>
.echarts-donut {
  width: 100%;
  height: 100%;
  min-height: 150px;
}
</style>
